/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.20.0
 */

import { FC, Fragment } from 'react';

import get from 'lodash/get';
import { useSelector } from 'react-redux';

import { makeSelectExtFilter } from './SubscriberMobileExtFilter/extFilterSelectors';

enum ETableColumnUtilHideFilters {
    EMPTY = 'empty',
    STUB = 'stub',
}

const TableSubscriberFilter: FC = ({ children }) => {
    const extFilter = useSelector(makeSelectExtFilter());
    const hideFiltersType = get(extFilter, 'items', []).length !== 0 ? ETableColumnUtilHideFilters.STUB : undefined;

    if (hideFiltersType) return null

    return <Fragment>{children}</Fragment>;
};

export default TableSubscriberFilter;
